import { render, staticRenderFns } from "./SearchDataProjectModal.vue?vue&type=template&id=31effa96&scoped=true&"
import script from "./SearchDataProjectModal.vue?vue&type=script&lang=js&"
export * from "./SearchDataProjectModal.vue?vue&type=script&lang=js&"
import style0 from "./SearchDataProjectModal.vue?vue&type=style&index=0&id=31effa96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31effa96",
  null
  
)

export default component.exports